module.exports = __webpack_public_path__ + "media/images/emblems/CHE_Crans-Montana_COA-c87bcad571eb82033ff3ea441c7152ec.svg";